import * as React from "react";
import {Modal, Row, Col, Button, Form} from "react-bootstrap";
import {Formik} from "formik";
import * as Yup from "yup";

interface IProps {
    isOpen: boolean;
    handleClose: () => void;
    handleSubmit: (contractorName: string, contractorDescription: string, contractorFirstName: string, contractorLastName: string, contractorMobileNumber: string, contractorWorkPhone: string, contractorEmail: string) => void;
}

export default ({isOpen, handleClose, handleSubmit} : IProps) => (
    <Modal show={isOpen} onHide={() => handleClose()} centered>
        <Modal.Header>
            Add new Contractor
        </Modal.Header>
            <Formik
                initialValues={{
                    contractorName: "",
                    contractorDescription: "",
                    contractorFirstName: "",
                    contractorLastName: "",
                    contractorMobileNumber: "",
                    contractorWorkPhone: "",
                    contractorEmail: ""
                }}
                onSubmit={({contractorName, contractorDescription, contractorFirstName, contractorLastName, contractorMobileNumber, contractorWorkPhone, contractorEmail}) =>                 
                    handleSubmit(contractorName, contractorDescription, contractorFirstName, contractorLastName, contractorMobileNumber, contractorWorkPhone, contractorEmail)
                }
                validationSchema={
                    Yup.object().shape({
                        contractorName: Yup.string().required(),
                        contractorDescription: Yup.string().required(),
                        contractorFirstName: Yup.string().required(),
                        contractorLastName: Yup.string().required(),
                        contractorMobileNumber: Yup.string(),
                        contractorWorkPhone:Yup.string(),
                        contractorEmail: Yup.string().email().required()
                    })
                }
            >
                {(props) => (
                    <Form onSubmit={props.handleSubmit} noValidate={true}>
                        
                        <Modal.Body>
                        
                            <Form.Group>
                                <Form.Label>Contractor name</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="contractorName" 
                                    onChange={props.handleChange} 
                                    onBlur={props.handleBlur} 
                                    value={props.values.contractorName} 
                                    isInvalid={!!props.errors.contractorName}
                                />
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>Contractor description</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    as="textarea"
                                    name="contractorDescription" 
                                    onChange={props.handleChange} 
                                    onBlur={props.handleBlur} 
                                    value={props.values.contractorDescription}
                                    isInvalid={!!props.errors.contractorDescription} 
                                />
                            </Form.Group>


                            <Row>
                                <Col>

                                    <Form.Group>
                                        <Form.Label>Contractor person first name</Form.Label>
                                        <Form.Control 
                                            type="text"
                                            name="contractorFirstName"
                                            onChange={props.handleChange} 
                                            onBlur={props.handleBlur} 
                                            value={props.values.contractorFirstName} 
                                            isInvalid={!!props.errors.contractorFirstName}
                                        />
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>Contractor person last name</Form.Label>
                                        <Form.Control 
                                            type="text"
                                            name="contractorLastName"
                                            onChange={props.handleChange} 
                                            onBlur={props.handleBlur} 
                                            value={props.values.contractorLastName} 
                                            isInvalid={!!props.errors.contractorLastName}
                                        />
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>Mobile number</Form.Label>
                                        <Form.Control 
                                            type="text"
                                            name="contractorMobileNumber"
                                            onChange={props.handleChange} 
                                            onBlur={props.handleBlur} 
                                            value={props.values.contractorMobileNumber} 
                                            isInvalid={!!props.errors.contractorMobileNumber}
                                        />
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>Work phone</Form.Label>
                                        <Form.Control 
                                            type="text"
                                            name="contractorWorkPhone"
                                            onChange={props.handleChange} 
                                            onBlur={props.handleBlur} 
                                            value={props.values.contractorWorkPhone} 
                                            isInvalid={!!props.errors.contractorWorkPhone}
                                        />
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>Email address</Form.Label>
                                        <Form.Control 
                                            type="text"
                                            name="contractorEmail"
                                            onChange={props.handleChange} 
                                            onBlur={props.handleBlur} 
                                            value={props.values.contractorEmail} 
                                            isInvalid={!!props.errors.contractorEmail}
                                        />
                                    </Form.Group>
                                
                                </Col>
                                <Col></Col>
                            </Row>

                            </Modal.Body>
                            <Modal.Footer>
                                <div className="w-100">
                                    <Row>
                                        <Col md={6} xs={12}>
                                            <Button variant="outline-primary" onClick={() => handleClose()}>Cancel</Button>   
                                        </Col>
                                        <Col md={6} xs={12} className="text-right order-12">
                                            <Button type="submit">Save contactor</Button>                                
                                        </Col>
                                    </Row>
                                </div>
                            </Modal.Footer>
                    </Form>
                )}
            </Formik>


       
    </Modal>
)